import { BigNumber, utils } from 'ethers';

export const formatBigNumber = (bigNumber: BigNumber, decimals?: number) => {
  if (!bigNumber) return;
  if (decimals) return utils.formatUnits(bigNumber, decimals);
  return utils.formatEther(bigNumber);
};
